import { ReviewForm } from "~/components/BTSInProductVideoPage/Review/Modals/reviewTypes";
import { ReviewFormOrchestrator } from "~/components/BTSInProductVideoPage/Review/ReviewFormOrchestrator";
import { OverlayModal } from "~/components/common/OverlayModal";

import * as styles from "./Modals.css";

interface Props extends Exclude<React.ComponentProps<typeof OverlayModal>, "contentClass"> {
  activeReviewModal: ReviewForm;
  handlePrevious: () => void;
  setActiveModal: (reviewForm: ReviewForm) => void;
}

export const ReviewModal = ({
  activeReviewModal,
  handlePrevious,
  setActiveModal,
  ...overlayModalProps
}: Props) => {
  return (
    <OverlayModal
      {...overlayModalProps}
      onPrevious={activeReviewModal === ReviewForm.Rate ? undefined : handlePrevious}
      contentClass={styles.content}
      onClose={overlayModalProps.onClose}
    >
      {overlayModalProps.isOpen ? (
        <ReviewFormOrchestrator activeModal={activeReviewModal} setActiveModal={setActiveModal} />
      ) : (
        <></>
      )}
    </OverlayModal>
  );
};
